var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feedback-form',{ref:"feedbackForm",attrs:{"title":_vm.title,"description":_vm.description,"button":_vm.button},on:{"send-form":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }